module.exports = __webpack_public_path__ + "static/harlan-coben-67bb9b48b1ef78c1657fb33ca14b0418.jpg";